<vti-notification></vti-notification>
<vti-confirm></vti-confirm>
<div class="inset-0 h-full w-full min-h-full">
  @if (isSignedIn()) {
    <div class="flex flex-col h-screen justify-between">
      <header>
        <vti-header></vti-header>
      </header>
      <main class="-mt-32 flex-grow mb-auto">
        <div class="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8 bg-white border rounded-md">
          <router-outlet />
        </div>
      </main>
      <footer>
        <vti-footer></vti-footer>
      </footer>
    </div>
  } @else {
    <div class="isolate overflow-hidden bg-white">
      <img src="assets/images/amazonie.jpg" alt="" class="absolute inset-0 -z-10 h-full w-full min-h-full object-cover" />
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl pt-24">
          <div class="hidden sm:mb-8 sm:flex sm:justify-center">
            <div class="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-400 ring-1 ring-white/10 hover:ring-white/20"></div>
          </div>
          <div class="text-center">
            <h1 class="text-4xl font-bold tracking-tight text-white sm:text-6xl" i18n>ViridisTerra Investor Portal</h1>
            <div class="mt-8 z-50 text-left">
              <amplify-authenticator [services]="services(this)" initialState="signIn" [hideSignUp]="true" [formFields]="formFields">
                <ng-template amplifySlot="sign-in-header">
                  <h2 class="amplify-heading" style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl); font-size: medium; font-weight: bold" i18n>Welcome, please sign in your account</h2>
                </ng-template>
                <ng-template amplifySlot="footer">
                  @if (biometricActivated()) {
                    <div class="mt-4 flex items-center justify-center" (click)="biometricLogin()">
                      <vti-round-button [icon]="'biometric'" [iconSize]="10" (onClick)="biometricLogin()" [padding]="true"> </vti-round-button>
                    </div>
                  }
                </ng-template>
              </amplify-authenticator>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
